import { Icon } from "@chakra-ui/react";
const WifiIcon = () => {
  return (
    <>
      <Icon
        width="18"
        height="22"
        viewBox="0 0 24 19"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M11.62 0C7.41 0 3.32 1.41 0 4C4.03 9.06 7.51 13.37 11.62 18.5C15.7 13.42 19.86 8.24 23.27 4C19.94 1.41 15.84 0 11.62 0Z"
          fill="#CCF0F7"
        />
      </Icon>
    </>
  );
};
export default WifiIcon;
